import {
  getTransactionDateColumn,
  getCounterpartyNameColumn,
  getCounterPartyAccountNumberColumn,
  getTransactionDescriptionColumn,
  getIncomeColumn,
  getExpenseColumn,
  getRateColumn,
  getBalanceColumn,
} from "./statementColumnsHelpers"; // adjust path

export function createBankStatementColumns({ currency }) {
  return [
    getTransactionDateColumn(),
    getCounterpartyNameColumn(),
    getCounterPartyAccountNumberColumn({ copyable: true }),
    getTransactionDescriptionColumn(),
    getIncomeColumn(currency),
    getExpenseColumn(currency),
    getRateColumn(),
    getBalanceColumn(currency, { strong: true }),
  ];
}